import $axios from './apiConnection'
import instance from './apiConnectionExternal'
import parseCatch from '../helpers/handleErrors'
import store from '@/store/store'
import momentTimezone from 'moment-timezone'
import {GmtOffsetTypes} from '@/enum/gmt'

function getGmtOffset (GMTOffsetData) {
    if (Number(GMTOffsetData.Type) === GmtOffsetTypes.Account) {
        const allAccounts =  store.getters['entities/getEntityList']('Accounts')
        const currentAccount = allAccounts.find(el => el.AccountID === Number(GMTOffsetData.AccountID))
        return currentAccount.GmtOffset
    } else if (Number(GMTOffsetData.Type) === GmtOffsetTypes.Browser) {
        return new Date().getTimezoneOffset() * 60
    } else {
        const GMTOffset = momentTimezone().tz(GMTOffsetData.GMTOffset).utcOffset() * 3600
        return GMTOffset / 60
    }
}

export const WidgetDataApi = {
    async getData(endPoint) {
        const dashboardStore = store.getters['dashboards/getActiveDashboard']
        try {
            const DashboardConf = dashboardStore.DashboardConf && 'GMTOffsetData' in dashboardStore.DashboardConf ? dashboardStore.DashboardConf.GMTOffsetData : {
                Type: GmtOffsetTypes.Browser
            }
            let res = await $axios.post(endPoint, {}, {headers: {
                "x-GmtOffset": getGmtOffset(DashboardConf),
                "GmtOffsetType": DashboardConf.Type
            }})
            return res.Data
        } catch (e) {
            parseCatch(e, true)
            return Promise.reject(e)
        }
    },

    async getExternalData(endPoint) {
        try {
            let res = await instance.get(endPoint)
            return res.Data ? res.Data : res
        } catch (e) {
            parseCatch(e, true)
        }
    }
}
